export default "__VITE_ASSET__BPWpv7lg__"